import { CSSProperties } from "react";

import css from "./interactive_table.module.scss";

type SelectionBorderProps = {
  boxShadow: CSSProperties["boxShadow"];
};

export const SelectionBorder = ({ boxShadow }: SelectionBorderProps) => (
  <div className={css.selectionBorder} style={{ boxShadow }} />
);
